import { useEffect, useState } from 'react';
import { Accordion, AccordionSummary, Typography, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useSearchParams } from 'react-router-dom';
import BadgeNumber from 'components/BadgeNumber';
import FormBuilder from 'containers/FormBuilder';
import { Form2Section1Fields } from 'constants/form-2-section-1-fields';
import DoneIcon from '@mui/icons-material/Done';
import CircularIcon from 'components/CircularIcon';
import { useController } from 'react-hook-form';
import BottomButton from 'components/BottomButton';

export default function FormStep2Section1Container() {
  const [searchParams] = useSearchParams();
  const section = searchParams.get('section') || '1';
  const [isAccordionExpanded, setIsAccordionExpanded] = useState(false);
  const { formState } = useController({ name: 'entity' });
  const { field, fieldState } = useController({ name: 'entity.izin_usaha' });

  useEffect(() => {
    setIsAccordionExpanded(section === '1');
  }, [section]);

  useEffect(() => {
    if (fieldState.error) {
      setIsAccordionExpanded(true);
    }
  }, [fieldState.error]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Accordion
      expanded={isAccordionExpanded}
      onChange={() => ['3', '2', '1'].includes(section) && setIsAccordionExpanded((prev) => !prev)}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
        {section <= '1' ? (
          <BadgeNumber>1</BadgeNumber>
        ) : (
          <CircularIcon>
            <DoneIcon />
          </CircularIcon>
        )}
        <Typography color="surface.700" variant="h6" sx={{ marginLeft: 1 }}>
          Perusahaan
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        {['3', '2', '1'].includes(section) && <FormBuilder formFields={Form2Section1Fields(field)} />}
      </AccordionDetails>
      {section === '1' && <BottomButton isButtonLoading={formState.isSubmitting} />}
    </Accordion>
  );
}
